module.exports = __webpack_public_path__ + "static/Dafiti1-53defd765b62ca0c09c27155e1018f23.png";